import { Api } from 'utils';

/**
 * Un método por endpoint de src/controllers/web/admin/analytics/* (backend),
 * agrupado por dominio -- mismo patrón que HomeService.admin.
 */
class AnalyticsService {
  static users = {
    registrationHistory: async (params = {}) =>
      Api.createResponse('admin/analytics/users/registration-history', params),
  };

  static memberships = {
    active: async (params = {}) => Api.createResponse('admin/analytics/memberships', params),
    purchaseHistory: async (params = {}) =>
      Api.createResponse('admin/analytics/memberships/purchase-history', params),
  };

  static chat = {
    statusSummary: async (params = {}) =>
      Api.createResponse('admin/analytics/chat/status-summary', params),
    responseTimes: async (params = {}) =>
      Api.createResponse('admin/analytics/chat/response-times', params),
    creationHistory: async (params = {}) =>
      Api.createResponse('admin/analytics/chat/creation-history', params),
  };

  static revision = {
    totals: async (params = {}) => Api.createResponse('admin/analytics/revision/totals', params),
    internalVsExternal: async (params = {}) =>
      Api.createResponse('admin/analytics/revision/internal-vs-external', params),
    creationHistory: async (params = {}) =>
      Api.createResponse('admin/analytics/revision/creation-history', params),
  };

  static preparation = {
    totals: async (params = {}) => Api.createResponse('admin/analytics/preparation/totals', params),
    creationHistory: async (params = {}) =>
      Api.createResponse('admin/analytics/preparation/creation-history', params),
  };
}

export default AnalyticsService;
